import {
	defAction
}from "../../../../helpers/defaultAction"
import api from './api'
import {
	reCharacteristicConstants
}from "./constants"

export const reCharacteristicActions = {
	getList,
	getPaged,
	getPagedAll,
	getPagedAudit,
	create,
	remove,
	update,
	restore,
	clear
}

function getList(values){
	const dispatchObj = {
		constants : reCharacteristicConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPaged(values){
	const dispatchObj = {
		constants : reCharacteristicConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : reCharacteristicConstants.GetPagedAll,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function getPagedAudit(values){
	const dispatchObj = {
		constants : reCharacteristicConstants.GetPagedAudit,
		service   : {
			func   : api.getPagedAudit,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : reCharacteristicConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : reCharacteristicConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restore(values){
	const dispatchObj = {
		constants : reCharacteristicConstants.Restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : reCharacteristicConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reCharacteristicConstants.Clear
	})
}